import {getReport, isPhone, isHKPhone, getVerifyCode} from '../../js/axios'
import el from "element-ui/src/locale/lang/el";
export default {
    name:'getReport',
    data(){
        return{
            userName:'',
            phone:'',
            yzCode:'',
            userNameError:'',
            phoneError:false,
            yzCodeError:false,
            totalPage:1,
            tableData: [
            ],
            pageCount:1,
            tipStatus: "",
            tipText: "",
            alertShow: false,
            timeW:0,
            nameW:0,
            sexW:0,
            telW:0,
            packageW:0,
        }
    },
    mounted() {
        this.resizeChange();
        window.onresize = () => {
            return (() => {
                this.resizeChange()
            })();
        };
    },
    methods:{

        resizeChange() {
            let tableWidth = document.getElementsByClassName('el-table__body-wrapper')[0].offsetWidth;
            this.timeW = tableWidth * 0.17;
            this.nameW = tableWidth * 0.15;
            this.sexW = tableWidth * 0.15;
            this.telW = tableWidth * 0.17;
            this.packageW = tableWidth * 0.17;
        },

        handleClick(id,row) {
            // window.location.href = ''
            if(row.is_finish == '2'){
                if(location.href.indexOf('hkback.medinbd') == '-1'){
                    window.open('http://test.medinbd.com/download/'+row.id+'.html',"_blank");
                }else {
                    window.open('https://www.medinbd.com/download/'+row.id+'.html',"_blank");
                }
            }else if(row.is_finish == '90'){

            }else if(row.is_finish == '1'){

            }

        },
        confirmDialog() {
            this.alertShow = false;
        },
        closeDialog(){
            this.alertShow=false;
            //把绑定的弹窗数组 设为false即可关闭弹窗
        },

        // sendCode(){
        //     if(this.phone != ''){
        //         let data = {
        //             account: this.phone,
        //             type: 3,
        //             loa: isHKPhone(this.phone)?'00852':'86'
        //         };
        //         getVerifyCode({
        //             data: window.btoa(JSON.stringify(data))
        //         }).then((res)=>{
        //             if(res.status == 1){
        //                 console.log(res)
        //             }else{
        //                 this.$alert('手機號碼輸入錯誤！', '溫馨提示', {
        //                     confirmButtonText: '确定',
        //                     callback: action => {
        //
        //                     }
        //                 });
        //             }
        //         })
        //     }else {
        //         this.phoneError = true
        //     }
        // },
        getReportBtn(){
            if(this.userName  == ''){
                this.alertShow = true;
                this.tipStatus = "查詢失敗";
                this.tipText = "請填寫相關信息";
            }else if(!isPhone(this.phone) && !isHKPhone(this.phone) || this.phone == ''){
                this.alertShow = true;
                this.tipStatus = "查詢失敗";
                this.tipText = "請填寫正確的手機號碼";
            } else{
                let data = {
                    phone:this.phone,
                    name:this.userName,
                    page: this.totalPage,
                    pagesize:10
                };
                getReport(data).then((res)=>{
                    if(res.status == 1){
                        if(res.data.data != ''){
                            this.pageCount = parseInt(res.data.pager.count);
                            res.data.data.forEach((item)=>{
                                item.package = item.package == 1 ? '尊享套餐' : item.package == 1 ?'精英套餐' : '體驗套餐';
                                item.appoint = item.appoint == 1 ? '正常' : '預約';
                                item.sex = item.sex == 1 ? '男' : '女';
                            });
                            this.tableData = res.data.data
                        }else {
                            this.alertShow = true;
                            this.tipStatus = "查詢結果";
                            this.tipText = '暫無數據';
                        }
                    }else{
                        this.alertShow = true;
                        this.tipStatus = "查詢失敗";
                        this.tipText = res.msg;
                    }
                })
            }
        },
        onCurrentChange(val){
            this.totalPage = val;
            this.getReportBtn();
        }
    }
}
